import { RequisitesInfo } from "../../../Form/IForm";

export enum RequisitesActionType {
    LoadInitialRequisites = "LoadInitialRequisites",
}

export interface RequisitesAction {
    type: RequisitesActionType.LoadInitialRequisites;
    payload: RequisitesInfo;
}
